import type { ReactElement } from 'react'

export default function FormFooterEmpty(): ReactElement | null {
  // No op footer
  return null
}
